<div class="page-content">
    <div class="page-header">
        <h1> Planning de facturation </h1>
         <div class="page-description">
            <ed-select
                [ngModel]="year"
                [options]="yearsOptions"
                (ngModelChange)="onChangeYear($event)"
            >
            </ed-select>    
        </div>
    </div>

    <div class="page-body">
        <div class="row g-3">
             <div class="col-sm-6 col-lg-3 g-3">
                <kpi-card
                    title="Factures prévues"
                    [body]="{value: allBillingPending, suffix: ' € HT'}"
                    [badge]="{ value: lateBilling, suffix: ' en retard', style: lateBilling > 0 ? 'danger': 'success'}"
                    [isLoading]="isLoading"
                    class="h-100"></kpi-card>
            </div>
            <div class="col-sm-6 col-lg-3 g-3">
                <kpi-card
                    [title]="'Factures prévues en '+now.getFullYear()"
                    [body]="{value: thisYearBillingPending, suffix: ' € HT'}"
                    [badge]="{ value: 100*thisYearBillingPending/thisYearBillingTotal, suffix: '%'}"
                    [footer]="{ prefix: 'Total: ', value: thisYearBillingTotal, suffix: ' € HT'}"
                    [isLoading]="isLoading"
                    class="h-100"></kpi-card>
            </div>
            <div class="col-sm-6 col-lg-3 g-3">
                <kpi-card
                    [title]="'Factures prévues en '+now.toLocaleString('default', { month: 'long' })"
                    [body]="{value: thisMonthBillingPending, suffix: ' € HT'}"
                    [badge]="{ value: 100*thisMonthBillingPending/thisMonthBillingTotal, suffix: '%'}"
                    [footer]="{ prefix: 'Total: ', value: thisMonthBillingTotal, suffix: ' € HT'}"
                    [isLoading]="isLoading"
                    class="h-100"></kpi-card>
            </div>
            
            
        
        </div>
        <br/>

        <div class="row g-4">
            <div class="col-sm-12">
                <chart-card
                    id="Dashboard-billing-chart"
                    title="Factures"
                    [error]="billingMilestones.length === 0"
                    [isLoading]="isLoading"
                    [series]="billingSeries"
                    [stacked]="true"
                    [dataLabels]="billingDataLabels"                
                    [xaxisCategories]="billingXaxisCategories"
                    xaxisType="datetime"
                    type="bar"
                    [yaxis]="billingYaxis"
                    [precision]="0"
                    [yaxisPrecision]="0"
                    [stacked]="true"
                    class="h-100"></chart-card>
            </div>
        </div>
    
        <br/>
        <div class="row g-3">
            <div class="col-sm-12">
                 <table-card 
                        title="Factures prévues"
                        [sortInfo]="{field: 'plannedDate', order: 1}"
                        [isLoading]="isLoading" 
                        [dataSource]="billingPendingData" 
                        [displayedColumns]="billingPendingColumns"
                        (onRowClick)="goToProjectPage($event)"
                        >
                    </table-card>
            </div>
        </div><br/>

        <div class="row g-3">
            <div class="col-sm-12">
                 <table-card 
                        title="Factures envoyées"
                        [sortInfo]="{field: 'plannedDate', order: -1}"
                        [isLoading]="isLoading" 
                        [dataSource]="billingSentData" 
                        [displayedColumns]="billingSentColumns"
                        (onRowClick)="goToProjectPage($event)"
                        >
                    </table-card>
            </div>
        </div>
    </div>
</div>